import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-[#0369A1] py-20 px-4" data-id="element-153">
      <div className="max-w-4xl mx-auto text-center" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        scale: 0.5
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-block mb-8" data-id="element-155">
          <ShieldCheck className="w-24 h-24 text-[#F97316] mx-auto" data-id="element-156" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-3xl md:text-5xl font-bold text-white mb-8 uppercase tracking-wide" data-id="element-157">
          Garantía 7 días sin preguntas
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-xl md:text-2xl text-white/90 leading-relaxed mb-12 max-w-3xl mx-auto" data-id="element-158">
          Abrí los 16 Tomos. Revisá los 6 Bonus. Usá los Ebooks Élite en tu
          práctica. Si no es lo que esperabas → 100% de devolución. Sin
          preguntas. Sin formularios. Sin drama.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="inline-block bg-[#F97316] text-white font-bold text-xl md:text-2xl px-8 py-4 rounded-xl shadow-lg uppercase tracking-wider" data-id="element-159">
          TASA DE DEVOLUCIONES MENOR AL 2%
        </motion.div>
      </div>
    </section>;
}